/**
 * Tiny className joiner (U5). Accepts short-circuit expressions like
 * `error && 'is-invalid'` where the left side may be any falsy value.
 */
export function cx(...parts: Array<string | number | boolean | null | undefined>): string {
  return parts.filter((p): p is string => typeof p === 'string' && p.length > 0).join(' ');
}
